import UpgradeType from 'app/store/UpgradeType.js';
import App from 'app/app.js';
import 'app/service/RouterService.js';
import 'app/store/ShoppingCartStore.js';
import 'app/store/JobStore.js';
import 'app/components/yearbook-banner/yearbook-banner.component';

function LtOrderSummaryStepTwoCtrl(
  ShoppingCartStore,
  RouterService,
  JobStore,
  $uibModal,
  ProductCatalogStore,
  StandardizedEnhancementService,
  ItemService,
  VisualMerchandiseStore,
  LooksStore,
  ContentStore,
  ColorService,
  $filter,
  $scope,
  UserProfileStore,
  StudentBannerService
) {
  this.ORDERLINE_TYPE = { PACKAGE: 0, BUNDLE: 1, ADDON: 2, ENHANCEMENTS: { PERSONALIZATION: 3.1, RETOUCH: 3.2 } };
  this.openEnhancementView = true;
  this.isStandardizedPricingProgram = false;
  this.bundles = [];
  this.showAddons = false;
  this.showBundles = false;
  this.subjects = $scope.subjects;
  this.isUserLoggedIn = UserProfileStore.isLoggedIn();
  this.hideUserInfo = true;

  this.init = function () {
    this.orderData = R.map(function (subject) {
      return {
        bestUpgradesPackage: StandardizedEnhancementService.getWinningEnhancementPackage(subject.packages),
        name: subject.subjectFirstName,
        lastName: subject.subjectLastName,
        order: subject.getOrderLines(),
        schoolName: subject.portraitDashboard.accountName,
        jobKey: subject.portraitDashboard.jobKey,
        payOnly: JobStore.isPayOnly(subject.portraitDashboard.jobKey),
        collapsed: false,
        addOnsCollapsed: false,
        specialOffersCollapsed: false,
        accountName: subject.portraitDashboard.accountName,
        isReorder: JobStore.isReorder() || JobStore.isProofOrder(),
        eventDate: subject.portraitDashboard.eventDate,
        jobName: subject.portraitDashboard.jobName,
        lastPictureDay: subject.portraitDashboard.lastPictureDay,
        isEditingSoftMatch: !subject.subjectFirstName || !subject.subjectLastName || !subject.subjectGrade,
        firstName: subject.subjectFirstName,
        isUnderClassJob: JobStore.isUnderclass(subject.portraitDashboard.jobKey),
        gradeValue: $filter('ltTranslateFilter')('GRADE_' + subject.subjectGrade),
        isClassRoomGroupJob: JobStore.isClassRoomGroup(subject.portraitDashboard.jobKey),
        teacherName: subject.subjectTeacherName || '',
        dontKnowTeacherName: subject.dontKnowTeacherName == undefined ? true : subject.dontKnowTeacherName,
        lifetouchId: subject.portraitDashboard.lifetouchId,
        subject
      };
    })(this.subjects);
    this.isStandardizedPricingProgram = ProductCatalogStore.isStandardizedPricingProgram();
    this.productCatalog = ProductCatalogStore.getProductCatalog();
    this.bundles = this.updateBundles();

    R.forEachIndexed(
      function (orderView, index) {
        if (index > 0) {
          orderView.collapsed = true;
        }
      }.bind(this),
      this.orderData
    );

    if (ShoppingCartStore.getTotal() <= 0) {
      this.hideUserInfo = false;
    }
  };

  this.showBannerForSubject = () => StudentBannerService.isStudentBannerEnabled();

  this.getCartSubTotal = function () {
    return ShoppingCartStore.getAllItemsSubTotal();
  };

  this.getCartPromotionAmount = function () {
    return ShoppingCartStore.getPromotionAmount() + ShoppingCartStore.getCouponsTotalPromotionAmount();
  };

  this.getCartShippingPrice = function () {
    return ShoppingCartStore.getShippingUnitPrice();
  };

  this.getCartTax = function () {
    return ShoppingCartStore.getTotalTaxAmount();
  };

  this.getCartTotal = function () {
    return ShoppingCartStore.getTotal();
  };

  this.goToShoppingCart = function () {
    RouterService.goToShoppingCart();
  };

  this.calculateChildSalePrice = function (orderItems) {
    var orderableItemTotals = [],
      pullOrderableTotal = function (order) {
        orderableItemTotals.push(order.orderable.unitPrice);
      };

    R.forEach(pullOrderableTotal, orderItems);
    return R.sum(orderableItemTotals);
  };

  this.getShipToLocations = function (orderLine) {
    return R.uniq(
      R.map(function (orderLine) {
        return orderLine.shipToLocation;
      })(
        R.filter(function (orderLine) {
          return !!orderLine.orderable && !orderLine.orderable.upgrade;
        })(orderLine)
      )
    );
  };

  this.filterOrderDetail = function (shippingType, order) {
    if (shippingType === 'ENHANCEMENT') {
      return R.filter(function (orderDetail) {
        return (
          orderDetail.orderable.type === UpgradeType.PREMIUM_RETOUCHING ||
          orderDetail.orderable.type === UpgradeType.BASIC_RETOUCHING ||
          orderDetail.orderable.type === UpgradeType.PERSONALIZATION
        );
      })(order);
    } else {
      return R.filter(function (orderDetail) {
        return (
          (orderDetail.orderable.type &&
            orderDetail.shipToLocation === shippingType &&
            orderDetail.orderable.type !== UpgradeType.PREMIUM_RETOUCHING &&
            orderDetail.orderable.type !== UpgradeType.BASIC_RETOUCHING &&
            orderDetail.orderable.type !== UpgradeType.PERSONALIZATION) ||
          orderDetail.shipToLocation === shippingType
        );
      })(order);
    }
  };

  this.hasShipToLocation = function (location, childOrderLine) {
    return R.contains(location, this.getShipToLocations(childOrderLine));
  };

  this.isEnhancedPayOnly = function (jobKey) {
    return JobStore.isEnhancedPayOnly(jobKey);
  };

  this.openSubjectView = function (order) {
    order.collapsed = !order.collapsed;
  };

  this.showItemsSection = function (orderLineType, subjectIndex) {
    var flag = false;
    var subject = this.getSubjectOrder(subjectIndex);
    if (orderLineType === this.ORDERLINE_TYPE.PACKAGE) {
      flag = subject.packages.length > 0;
    } else if (orderLineType === this.ORDERLINE_TYPE.BUNDLE) {
      flag = subject.bundles.length > 0;
    } else if (orderLineType === this.ORDERLINE_TYPE.ADDON) {
      flag = this.getAddOns(subject).length > 0;
    } else if (orderLineType === this.ORDERLINE_TYPE.ENHANCEMENTS) {
      flag = subject.upgrades.length > 0;
      // Get enhancements that are included as part of the packages
      if (!flag) {
        subject.packages.forEach(function (pkg) {
          if (!flag) {
            flag = pkg.orderable.upgrades.length > 0;
          }
        });
      }
    }
    return flag;
  };

  this.getOrderLines = function (orderLineType, subjectIndex) {
    var that = this;
    var orderLines = null;
    var subjectOrder = this.getSubjectOrder(subjectIndex);

    if (!subjectOrder) {
      return orderLines;
    }

    if (orderLineType === this.ORDERLINE_TYPE.PACKAGE) {
      orderLines = subjectOrder.packages;
    } else if (orderLineType === this.ORDERLINE_TYPE.BUNDLE) {
      orderLines = subjectOrder.bundles;
    } else if (orderLineType === this.ORDERLINE_TYPE.ADDON) {
      orderLines = this.getAddOns(subjectOrder);
    } else if (orderLineType === this.ORDERLINE_TYPE.ENHANCEMENTS) {
      orderLines = subjectOrder.upgrades;
    }
    return orderLines;
  };

  this.getEnhancements = function (child) {
    const upgrades = child.order.flatMap((order) => this.getUpgradeFromOrderable(order.orderable));
    const retouchTypes = [UpgradeType.PREMIUM_RETOUCHING, UpgradeType.BASIC_RETOUCHING, UpgradeType.PERSONALIZATION];
    return retouchTypes.map((type) => upgrades.find((u) => u.type === type)).filter(Boolean);
  };

  this.getUpgradeFromOrderable = (orderable) => {
    if (orderable.upgrades) return orderable.upgrades;
    if (orderable.upgrade) return [orderable];
    return [];
  };

  this.openView = function (type, orderLine, subject) {
    if (type === this.ORDERLINE_TYPE.PACKAGE) {
      orderLine.packageCollapsed = !orderLine.packageCollapsed;
    } else if (type === this.ORDERLINE_TYPE.ADDON) {
      subject.addOnsCollapsed = !subject.addOnsCollapsed;
    } else if (type === this.ORDERLINE_TYPE.ENHANCEMENTS) {
      this.openEnhancementView = !this.openEnhancementView;
    } else if (type === this.ORDERLINE_TYPE.BUNDLE) {
      subject.specialOffersCollapsed = !subject.specialOffersCollapsed;
    }
  };

  this.isOrderLineCustomizable = function (orderLine) {
    var isItemCustomizable = function (orderLineDetail) {
      return orderLineDetail.item.lookSelectionAllowed;
    };
    return orderLine.orderable.substitutable || R.any(isItemCustomizable)(orderLine.orderLineDetails);
  };

  this.isLNSSTextBasedPersonalizerBundleItem = function (orderLine) {
    return R.any(ItemService.shoppingCartTextBasedPersonalizerEnabled)(orderLine.orderLineDetails);
  };

  this.isModelImage = function (orderLineDetail, orderLine) {
    return ItemService.isModelImage(orderLineDetail, orderLine);
  };

  this.isProductImage = function (orderLineDetail, orderLine) {
    return ItemService.isProductImage(orderLineDetail, orderLine);
  };

  this.showClassRoomPrintSheet = function (orderLineDetail) {
    return (
      !orderLineDetail.item.lookSelectionAllowed &&
      orderLineDetail.item.displayGroup == 'DG_OTHER' &&
      orderLineDetail.item.nameDesc.includes('Class Picture')
    );
  };

  this.getOrderLineDefaultLookImage = function (orderLineDetail) {
    return LooksStore.getPreviewImageLocation(orderLineDetail.look);
  };

  this.getProductImage = function (item) {
    return ContentStore.getProductImage(item.skuCode, item.defaultLayoutThemeId);
  };

  this.isPremiumBackground = function (item) {
    return item.type === UpgradeType.BACKGROUND;
  };

  this.getPremiumBgProductImage = function (look) {
    return ContentStore.resolveContentImagePath(LooksStore.getPreviewImageLocation(look));
  };

  this.isLNSSTextBasedPersonalizerItem = function (item) {
    return ItemService.isTextBasedPersonalizerEnabled(item);
  };

  this.isNoGoItem = function (item) {
    return item.templateName === 'Personalization_Prism_NOGO';
  };

  this.updateBundles = function () {
    const self = this;
    return R.mapIndexed(function (bundle, idx) {
      return {
        bundle: bundle,
        lookSelectionAllowed: R.any(R.propEq('lookSelectionAllowed', true))(bundle.items),
        cssClass: ColorService.getColor(idx),
        subtitle: $filter('ltTranslateFilter')('BUNDLE_SUBTITLE_' + bundle.skuCode),
        romance: $filter('ltTranslateFilter')('BUNDLE_ROMANCE_' + bundle.skuCode),
        banner: $filter('ltTranslateFilter')('BUNDLE_BANNER_' + bundle.skuCode),
        image: self.getBundleImage(bundle.skuCode)
      };
    }, this.productCatalog.bundles);
  };

  this.getBundleImage = function (skuCode) {
    return ContentStore.getBundleImage(skuCode, 'MOBILE_TRANS_SHOPPING_CART');
  };

  this.getBundlesUnitPriceTotal = function (subjectIndex) {
    //Calculating total Unit Price of Special Offers
    var bundlesUnitPriceTotal = 0;
    this.subjects[subjectIndex].bundles.forEach(function (orderLine) {
      bundlesUnitPriceTotal += orderLine.orderable.unitPrice;
    });
    return bundlesUnitPriceTotal;
  };

  this.getBundlesDiscountPriceTotal = function (subjectIndex) {
    var bundlesDiscountPriceTotal = 0;
    if (this.subjects[subjectIndex].packages.length > 0) {
      var discountsFlag = !!R.find(function (orderLine) {
        return (
          orderLine.orderable.discountedPriceWithPackage &&
          orderLine.orderable.unitPrice > orderLine.orderable.discountedPriceWithPackage
        );
      })(this.subjects[subjectIndex].bundles || []);
      this.subjects[subjectIndex].bundles.forEach(function (orderLine) {
        if (discountsFlag) {
          bundlesDiscountPriceTotal +=
            orderLine.orderable.discountedPriceWithPackage != null &&
            orderLine.orderable.unitPrice > orderLine.orderable.discountedPriceWithPackage
              ? orderLine.orderable.discountedPriceWithPackage
              : orderLine.orderable.unitPrice;
        } else {
          bundlesDiscountPriceTotal +=
            orderLine.orderable.discountedPriceWithPackage != null &&
            orderLine.orderable.unitPrice > orderLine.orderable.discountedPriceWithPackage
              ? orderLine.orderable.discountedPriceWithPackage
              : 0;
        }
      });
    }
    return bundlesDiscountPriceTotal;
  };

  this.getAddOnsPrice = function (orderType, subjectIndex) {
    var subjectOrder = this.getSubjectOrder(subjectIndex);
    var that = this;
    var orderLines = null;
    if (orderType === this.ORDERLINE_TYPE.ADDON) {
      orderLines = this.getAddOns(subjectOrder);
    } else if (orderType === this.ORDERLINE_TYPE.BUNDLE) {
      orderLines = subjectOrder.bundles;
    } else if (orderType === this.ORDERLINE_TYPE.ENHANCEMENTS) {
      orderLines = subjectOrder.upgrades;
    }
    if (orderLines && orderLines.length > 0) {
      if (orderType === this.ORDERLINE_TYPE.ADDON) {
        that.addOnsPrice = 0;
        that.showAddons = true;
        orderLines.forEach(function (orderLine) {
          that.addOnsPrice +=
            subjectOrder.packages.length > 0 &&
            orderLine.orderable.discountedPriceWithPackage != null &&
            orderLine.orderable.unitPrice > orderLine.orderable.discountedPriceWithPackage
              ? orderLine.orderable.discountedPriceWithPackage
              : orderLine.orderable.unitPrice;
        });
        return that.addOnsPrice;
      } else if (orderType === this.ORDERLINE_TYPE.BUNDLE) {
        that.showBundles = true;
        that.bundlesPrice = 0;
        orderLines.forEach(function (orderLine) {
          that.bundlesPrice += orderLine.orderable.unitPrice;
        });
        return that.bundlesPrice;
      } else if (orderType === this.ORDERLINE_TYPE.ENHANCEMENTS) {
        that.enhancementsPrice = 0;
        orderLines.forEach(function (orderLine) {
          that.enhancementsPrice += orderLine.orderable.unitPrice;
        });
        return that.enhancementsPrice;
      }
    } else {
      if (orderType === this.ORDERLINE_TYPE.ADDON) {
        that.showAddons = false;
      } else if (orderType === this.ORDERLINE_TYPE.BUNDLE) {
        that.showBundles = false;
      } else if (orderType === this.ORDERLINE_TYPE.ENHANCEMENTS) {
        that.enhancementsPrice = 0;
        return that.enhancementsPrice;
      }
    }
  };

  this.getSubjectOrder = function (orderIndex) {
    return orderIndex >= 0 ? this.subjects[orderIndex] : this.subjects[0];
  };

  this.getAddOnsUnitPriceTotal = function (subjectIndex) {
    return this.getAddOns(this.subjects[subjectIndex])
      .filter((orderLine) => !orderLine.orderable.freeGift)
      .reduce((total, orderLine) => total + orderLine.orderable.unitPrice, 0);
  };

  this.getNonFreeGiftAddOns = function (subject) {
    return (this.getAddOns(subject) || []).filter((orderLine) => !orderLine.orderable?.freeGift);
  };

  this.getAddOnsDiscountPriceTotal = function (subjectIndex) {
    let addOnsDiscountPriceTotal = 0;
    const subject = this.subjects[subjectIndex];

    if (subject.packages.length > 0) {
      const addOns = this.getNonFreeGiftAddOns(subject);

      const discountsFlag = !!R.find(function (orderLine) {
        return (
          orderLine.orderable.discountedPriceWithPackage &&
          orderLine.orderable.unitPrice > orderLine.orderable.discountedPriceWithPackage
        );
      })(addOns);

      addOns.forEach(function (orderLine) {
        const { unitPrice, discountedPriceWithPackage } = orderLine.orderable;

        const hasValidDiscount = discountedPriceWithPackage != null && unitPrice > discountedPriceWithPackage;

        const priceToUse = hasValidDiscount ? discountedPriceWithPackage : discountsFlag ? unitPrice : 0;

        addOnsDiscountPriceTotal += priceToUse;
      });
    }

    return addOnsDiscountPriceTotal;
  };

  this.getAddOns = (subject) => [...subject.addOns, ...subject.premiumBgAddons];

  this.showUserInfo = function () {
    return this.isUserLoggedIn && !this.hideUserInfo;
  };

  this.getDisplayDigitalDownload = (subject, orderLineDetail) => subject.firstDigitalDownloads.get(orderLineDetail);
}

App.controller('LtOrderSummaryStepTwoCtrl', [
  'ShoppingCartStore',
  'RouterService',
  'JobStore',
  '$uibModal',
  'ProductCatalogStore',
  'StandardizedEnhancementService',
  'ItemService',
  'VisualMerchandiseStore',
  'LooksStore',
  'ContentStore',
  'ColorService',
  '$filter',
  '$scope',
  'UserProfileStore',
  'StudentBannerService',
  LtOrderSummaryStepTwoCtrl
]);
